/**Organization types */

/**Organization types */
export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
export const EDIT_ORGANIZATION = 'EDIT_ORGANIZATION';
export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';

export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const GET_ORGANIZATION_BY_CATEGORIES = 'GET_ORGANIZATION_BY_CATEGORIES';

export const GET_BUSINESSES = 'GET_BUSINESSES';
export const GET_BUSINESSES_SUCCESS = 'GET_BUSINESSES_SUCCESS';

export const GET_ORGANIZATION_ADMINS = 'GET_ORGANIZATION_ADMINS';
export const GET_ORGANIZATION_ADMINS_SUCCESS = 'GET_ORGANIZATION_ADMINS_SUCCESS';
export const GET_ORGANIZATION_BY_CATEGORIES_SUCCESS = 'GET_ORGANIZATION_BY_CATEGORIES_SUCCESS';
export const GET_ORGANIZATION_SUCCESS = 'GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_BY_ID = 'GET_ORGANIZATION_BY_ID';
export const REMOVE_ORGANIZATION_BY_ID = 'REMOVE_ORGANIZATION_BY_ID';
export const GET_ORGANIZATION_BY_ID_SUCCESS = 'GET_ORGANIZATION_BY_ID_SUCCESS';

/**Claims types */
export const CLAIMS = 'CLAIMS';
export const CHECK_CLAIM = 'CHECK_CLAIM';
export const CHECK_CLAIM_SUCCESS = 'CHECK_CLAIM_SUCCESS';
export const GET_CLAIMS = 'GET_CLAIMS';
export const GET_CLAIMS_SUCCESS = 'GET_CLAIMS_SUCCESS';
export const APPROVE_CLAIMS = 'APPROVE_CLAIMS';
export const REJECT_CLAIMS = 'REJECT_CLAIMS';

/**Suggest */
export const GET_SUGGEST_INFO = 'GET_SUGGEST_INFO';
export const REMOVE_SUGGEST_INFO = 'REMOVE_SUGGEST_INFO';
export const GET_SUGGEST_INFO_SUCCESS = 'GET_SUGGEST_INFO_SUCCESS';

/**Edits types */
export const GET_EDITS = 'GET_EDITS';
export const GET_EDITS_SUCCESS = 'GET_EDITS_SUCCESS';
export const ACCEPT_OR_REJECT_EDIT = 'ACCEPT_OR_REJECT_EDIT';

/**Status */
export const SET_STATUS = 'SET_STATUS';

/**Events */
export const GET_EVENTS_BY_ORGANIZATION = 'GET_EVENTS_BY_ORGANIZATION';
export const GET_EVENTS_BY_ORGANIZATION_SUCCESS = 'GET_EVENTS_BY_ORGANIZATION_SUCCESS';

export const REMOVE_ORG_BY_ID = 'REMOVE_ORG_BY_ID';

/**Categories */
export const GET_ORG_CATEGORIES = 'GET_ORG_CATEGORIES';
export const GET_ORG_CATEGORIES_SUCCESS = 'GET_ORG_CATEGORIES_SUCCESS';

/**Follow */
export const GET_FOLLOWS = 'GET_FOLLOWS';
export const GET_FOLLOWS_SUCCESS = 'GET_FOLLOWS_SUCCESS';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';
export const EDIT_ORG_SOCIALS = 'EDIT_ORG_SOCIALS';
export const GET_ORG_SOCIALS = 'GET_ORG_SOCIALS';
export const GET_ORG_SOCIALS_SUCCESS = 'GET_ORG_SOCIALS_SUCCESS';
